import { WEB_SERVICES } from "../../../../bitSagas/webServices";
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      BUSINESS_ERRORS: {
      },
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT]: errorToPrint.INCOMPATIBLE_PRODUCT,
          [WEBSERVICE_ERRORS.MAX_CARDINALITY_REACHED]: errorToPrint.MAX_CARDINALITY_REACHED,
          [WEBSERVICE_ERRORS.OFFER_WITH_SOME_DEPENDENCIES]: errorToPrint.OFFER_WITH_SOME_DEPENDENCIES,
          [WEBSERVICE_ERRORS.WITHOUT_DEPENDENT_OFFER]: errorToPrint.WITHOUT_DEPENDENT_OFFER,
          [WEBSERVICE_ERRORS.TV_PRODUCT_REGISTERED]: errorToPrint.MAX_CARDINALITY_REACHED,
          [WEBSERVICE_ERRORS.INCORRECT_PRODUCT_OR_CQI]: errorToPrint.INCOMPATIBLE_PRODUCT,
        },
        [WEB_SERVICES.INIT_CQ_TV]: {
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT]: errorToPrint.INCOMPATIBLE_PRODUCT,
          [WEBSERVICE_ERRORS.MAX_CARDINALITY_REACHED]: errorToPrint.MAX_CARDINALITY_REACHED,
          [WEBSERVICE_ERRORS.OFFER_WITH_SOME_DEPENDENCIES]: errorToPrint.OFFER_WITH_SOME_DEPENDENCIES,
          [WEBSERVICE_ERRORS.WITHOUT_DEPENDENT_OFFER]: errorToPrint.WITHOUT_DEPENDENT_OFFER,
          [WEBSERVICE_ERRORS.TV_PRODUCT_REGISTERED]: errorToPrint.MAX_CARDINALITY_REACHED,
          [WEBSERVICE_ERRORS.INCORRECT_PRODUCT_OR_CQI]: errorToPrint.INCOMPATIBLE_PRODUCT,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
        },
      },
    },
    [`user_${USER_TYPE.OPEN}`]: {

    },
  }

  return handledErrors;
}
